import React from "react";
import { Carousel } from "react-bootstrap";

import "./Comments.css";

const Comments = () => {
  return (
    <div className="comments my-5 ">
      <div className="h-50 d-flex justify-content-center align-items-center ">
        <Carousel className="main-carousel mx-auto">
          <Carousel.Item className="carousel-item" interval={2000}>
            <section className="comment-container container mt-5">
              <div className="titile">
                <h2 className="text-center ">Customer Reviews</h2>
                <div className="unerline" />
              </div>

              <article className="review">
                <div className="img-container">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Emblem-person-blue.svg/1200px-Emblem-person-blue.svg.png"
                    id="person-img"
                    alt=""
                  />
                </div>
                <h4 id="author">Mr. Wabaidul Haque</h4>
                <p id="job">Member of SAC</p>
                <p id="info">Very good service. Highly Recommended</p>
              </article>
            </section>
          </Carousel.Item>
          <Carousel.Item className="carousel-item" interval={2000}>
            <section className="comment-container container mt-5">
              <div className="titile">
                <h2 className="text-center ">Our Reviews</h2>
                <div className="unerline" />
              </div>

              <article className="review">
                <div className="img-container">
                  <img
                    src="https://st4.depositphotos.com/9998432/24428/v/380/depositphotos_244284704-stock-illustration-person-gray-photo-placeholder-man.jpg?forcejpeg=true"
                    id="person-img"
                    alt=""
                  />
                </div>
                <h4 id="author">Saheel Ayeman</h4>
                <p id="job">Dhaka, Bangladesh</p>
                <p id="info">
                  Of course buying again from them. Great service.
                </p>
              </article>
            </section>
          </Carousel.Item>
          <Carousel.Item className="carousel-item" interval={5000}>
            <section className="comment-container container mt-5">
              <div className="titile">
                <h2 className="text-center ">Our Reviews</h2>
                <div className="unerline" />
              </div>

              <article className="review">
                <div className="img-container">
                  <img
                    src="https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"
                    id="person-img"
                    alt=""
                  />
                </div>
                <h4 id="author">Farhan Khan</h4>
                <p id="job">Cumilla IT & TECH Co.</p>
                <p id="info">
                  Consistently 5 stars. Highly recommended. Best of all, every
                  order!
                </p>
              </article>
            </section>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
};

export default Comments;
